import $ from 'jquery';
import React, { useState, useEffect } from 'react';
import Toastr from 'toastr';
import SessionManager from './../routes/SessionManager';
import ReactGA from 'react-ga4';
import DropdownButton from './../components/bootstrap4/DropdownButton';
import Input from '../components/bootstrap4/Input';
import CommonUtils from '../util/CommonUtils';
import API from '../service/SiteKickAPIService';

function ProfileSettings() {

    let sessionMgr = new SessionManager();
    let user1 = sessionMgr.readCookie('user');

    const [user, setUser] = useState({ ...user1 });
    const [site_locations, setSiteLocations] = useState([]);
    const [defaultViewChanged, setDefaultViewChanged] = useState(false);
    const [defaultSiteChanged, setDefaultSiteChanged] = useState(false);

    // This field added to show phone number in the ui
    user.phone_ui = user.phone_ui ? user.phone_ui : user.user_phone1;
    if (user.device_status_notify === undefined)
        user.device_status_notify = false;
    if (!user.defaultView)
        user.defaultView = "Dashboard"

    useEffect(() => {
        if (user.site_locations && user.site_locations.length > 0) {
            let siteDefault = user.site_selected;
            if (!siteDefault)
                siteDefault = onDefaultSiteChange(user.site_selected);
            setSiteLocations(user.site_locations);
        } else {
            fetchSiteLocations();
        }
        $('[data-toggle="tooltip"]').tooltip({ html: true });
    }, []);

    const fetchSiteLocations = () => {
        var data = {
            customer_id: user.customer_id,
            site_id: user.user_sites,
            user_login: user.user_login,
            user_token: user.user_token
        }

        CommonUtils.ajax(
            {
                url: API.SITE.BASE,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    let site_locations = res.data ? res.data.filter(x => x.site_state !== 'Inactive') : [];
                    setSiteLocations(site_locations);
                }
            },
            (res) => {

            });
    }

    const onDefaultSiteChange = (site_selected) => {
        if (user.site_id !== site_selected.site_id) {
            var user1 = { ...user };
            user1.site_id = site_selected.site_id;
            setUser(user1);
            setDefaultSiteChanged(true);
        }

        // var sessionMgr = new SessionManager();
        var prevUser = sessionMgr.readCookie("user");
        if (prevUser.site_id === site_selected.site_id) {
            setDefaultSiteChanged(false);
        }
    }

    const saveDefaultSite = (event) => {
        var data = {
            form_input: { site_id: user.site_id },
            customer_id: user.customer_id,
            user_login: user.user_login,
            user_token: user.user_token
        }

        var basicInputs = { site_id: null };
        for (var k in basicInputs) {
            if (data.form_input[k] == null) {
                Toastr.error('All fields are mandatory !');
                return;
            } else {
                basicInputs[k] = data.form_input[k];
            }
        }
        data.form_input = basicInputs;

        var saveBtn = event.target;
        saveBtn.innerHTML = 'Saving ...';

        CommonUtils.ajax(
            {
                url: API.USER.MODIFY,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    Toastr.success('Changes saved successfully !');
                }

                var sessionMgr = new SessionManager();
                var user1 = { ...user };
                delete user1.defaultSiteChanged; // No need to store in cookie.
                sessionMgr.storeCookie('user', user1);

                saveBtn.innerHTML = 'Save';
                setUser(user1);
                setDefaultSiteChanged(false);
            },
            (res) => {
                saveBtn.innerHTML = 'Save';
                setDefaultSiteChanged(false);
            }
        );
    }

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        var user1 = { ...user };
        user1[name] = value;
        setUser(user1);
    }

    const saveLoginInfo = (event) => {

        if (user.user_pass_new !== user.user_pass_new_confirm) {
            Toastr.error('New password and Confirm password do not match !');
            return;
        }

        if (user.user_pass_new === user.user_pass) {
            Toastr.error('Old password and new password can\'t be same !');
            return;
        }

        var data = {
            form_input: { ...user },
            customer_id: user.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token
        }

        var loginInputs = { user_pass: null, user_pass_new: null };
        for (var k in loginInputs) {
            if (data.form_input[k] == null || data.form_input[k] === '') {
                Toastr.error('All fields are mandatory !');
                return;
            } else {
                loginInputs[k] = data.form_input[k];
            }
        }
        data.form_input = loginInputs;

        var saveBtn = event.target;
        saveBtn.innerHTML = 'Saving ...';

        CommonUtils.ajax(
            {
                url: API.USER.MODIFY,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    saveBtn.disabled = true;
                    Toastr.success('Changes saved successfully !');
                    saveBtn.innerHTML = 'Save';
                    setTimeout(function () { $('.password').val(''); }, 50);
                    var user1 = { ...user };
                    user1['user_pass'] = "";
                    user1['user_pass_new'] = "";
                    user1['user_pass_new_confirm'] = "";
                    setUser(user1)
                } else {
                    saveBtn.innerHTML = 'Save';
                    setTimeout(function () { $('.cur_password').val(''); }, 50);
                    Toastr.error('Current password do not match !');
                }
            },
            (res) => {
                saveBtn.innerHTML = 'Save';
            }
        );
    }

    const isModifiedBasicInfo = () => {
        var sessionMgr = new SessionManager();
        let userPrev = sessionMgr.readCookie("user");
        let user_state = { ...user };
        let keys = ["user_name", "user_email1", userPrev["phone_ui"] ? "phone_ui" : "user_phone1", "user_sns_email", "user_sns_phone", "device_status_notify"];
        for (var k of keys) {
            if (userPrev[k] !== user_state[k]) {
                return false;
            }
        }
        return true;
    }

    const saveBasicInfo = (event) => {

        var data = {
            form_input: { ...user },
            customer_id: user.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token
        }

        var basicInputs = { user_name: null, user_email1: null, phone_ui: null, user_sns_email: false, user_sns_phone: false, device_status_notify: false };//user_phone1: null,
        for (var k in basicInputs) {
            if (data.form_input[k] == null || data.form_input[k] === '') {
                Toastr.error('All fields are mandatory !');
                return;
            }
            else {
                const element = document.getElementsByName(k)[0]
                const lIsValidText = $(element).attr("isvalidtext")
                if (lIsValidText === "true" || lIsValidText === true) {
                    if (k === "phone_ui") {
                        var phone = data.form_input[k]
                        phone = phone.replace(/[^\d]/g, "");
                        phone = "+1 " + phone.substr(0, 3) + " " + phone.substr(3, 3) + " " + phone.substr(6);

                        // Set the updated format phone number for sns service
                        basicInputs["user_phone1"] = phone
                    }
                    basicInputs[k] = data.form_input[k];
                }
                else {
                    const lErrorText = $(element).attr("invaliderrormsg")

                    const position = Toastr.options.positionClass
                    Toastr.options.positionClass = 'toast-top-center';
                    Toastr.error(lErrorText);
                    Toastr.options.positionClass = position;
                    return;
                }
            }
        }
        data.form_input = basicInputs;

        var saveBtn = event.target;
        saveBtn.innerHTML = 'Saving ...';
        saveBtn.disabled = true;

        CommonUtils.ajax(
            {
                url: API.USER.MODIFY,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    Toastr.success('Changes saved successfully !');

                    var user1 = { ...user };
                    for (var k in basicInputs) {
                        user1[k] = basicInputs[k];
                    }
                    new SessionManager().storeCookie('user', user1); // Update basic info in cookie.
                    setUser(user1);
                }
                saveBtn.innerHTML = 'Save';
            },
            (res) => {
                saveBtn.innerHTML = 'Save';
            });
    }

    const handleCheckBoxChange = (event) => {
        var att = event.target.getAttribute('for');
        var user1 = { ...user };
        user1[att] = !user1[att];

        setUser(user1);

        if (!user1.user_sns_email && !user1.user_sns_phone) {
            user1["device_status_notify"] = false
            setUser(user1);
        }

        ReactGA.event({
            category: 'Action',
            action: 'Clicked setting notification',
            label: 'Notify Preference Changed '
        });
    }

    const handleDefaulViewChange = (defaultView) => {

        if (user.defaultView !== defaultView) {
            var user1 = { ...user };
            user1.defaultView = defaultView;
            setUser(user1);
            setDefaultViewChanged(true);
        }

        var sessionMgr = new SessionManager();
        var prevUser = sessionMgr.readCookie("user");
        if (prevUser.defaultView === defaultView) {
            setDefaultViewChanged(false);

        }
    }

    const saveDefaultView = (event) => {

        var saveBtn = event.target;
        saveBtn.innerHTML = 'Saving ...';

        var data = {
            form_input: { defaultView: user.defaultView },
            customer_id: user.customer_id,
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id
        }

        CommonUtils.ajax(
            {
                url: API.USER.MODIFY,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    var sessUser = sessionMgr.readCookie('user');
                    var user1 = { ...user };
                    sessUser.defaultView = user1.defaultView;
                    sessUser.default_dashboard = user1.defaultView;
                    sessionMgr.storeCookie('user', sessUser);
                    Toastr.success('Changes saved successfully !');
                }
                saveBtn.innerHTML = 'Save';
                setDefaultViewChanged(false);

            },
            (res) => {
                saveBtn.innerHTML = 'Save';
                setDefaultViewChanged(false);

            });

    }

    const defaultSite = user ? user.site_id : '';
    return (
        <React.Fragment>
            <div className="page-container">
                <div className="row">
                    <div className="col-md-12 p-2">
                        <b>Hi {user.user_name}</b>, <br /><span className="font-size-12">Welcome To Your Profile Settings ...</span>
                    </div>
                </div>
                <div className="row p-2 bg-light">
                    <div className="col-md-12 font-weight-700">Basic Info :</div>
                </div>
                <div className="row py-4 bg-white">
                    <div className="col-md-4 form-group">
                        <label className="font-weight-300">User Name</label>
                        <Input onChange={handleInputChange} name="user_name" value={user.user_name} type="text" className="form-control" placeholder="Email / User Name" required="" autoComplete="off" />
                    </div>
                    <div className="col-md-4 form-group">
                        <label className="font-weight-300">Email 1</label>
                        <Input onChange={handleInputChange} name="user_email1" value={user.user_email1} type="email" className="form-control" placeholder="Primary Email" required="" />
                    </div>
                    <div className="col-md-4 form-group">
                        <label className="font-weight-300">Phone 1</label>
                        <Input onChange={handleInputChange} name="phone_ui" value={user.phone_ui} type="phone" className="form-control" placeholder="Primary Contact" required="" />
                    </div>

                    <div className="col-md-12 text-app mt-5 pb-3">
                        <b>How would you like to be notified ?</b>
                    </div>
                    <div className="col-md-12">
                        <div className="row mb-2">
                            <div className="col-md-8">
                                <i className={user.user_sns_email ? "fa fa-lg fa-check-square px-2 text-primary" : "far fa-lg fa-square px-2  text-primary"} htmlFor="user_sns_email" onClick={handleCheckBoxChange}></i>
                                <label className="font-weight-300 w-300" >Email Notifications</label>
                                <Input onChange={handleInputChange} name="user_sns_email" value={user.user_sns_email} type="hidden" className="form-control " placeholder="Email Notifications" required="" autoComplete="off" />

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8">
                                <i className={user.user_sns_phone ? "fa fa-lg fa-check-square px-2 text-primary" : "far fa-lg fa-square px-2  text-primary"} htmlFor="user_sns_phone" onClick={handleCheckBoxChange}></i>
                                <label className="font-weight-300 w-300" >SMS Notifications</label>
                                <Input onChange={handleInputChange} name="user_sns_phone" value={user.user_sns_phone} type="hidden" className="form-control " placeholder="SMS Notifications" required="" autoComplete="off" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8" >
                                <i className={user.device_status_notify ? "fa fa-lg fa-check-square px-2 text-primary" : (user.user_sns_phone || user.user_sns_email) ? "far fa-lg fa-square px-2 text-primary" : "far fa-lg fa-square px-2 text-primary disabled-checkbox"} htmlFor="device_status_notify" onClick={handleCheckBoxChange}></i>
                                <label className="font-weight-300 w-300 mt-1" >Gateway Connect/Disconnect Notifications</label>
                                <Input onChange={handleInputChange} name="device_status_notify" value={user.device_status_notify} type="hidden" className="form-control " placeholder="Gateway Notifications" required="" autoComplete="off" />
                            </div>
                        </div>
                        {
                            (!user.user_sns_phone && !user.user_sns_email) &&
                            <small className="pl-4"><i className="fa fa-lg fa-info-circle text-primary"></i> Email or SMS Notifications should be enabled to enable gateway notifications.</small>
                        }
                    </div>
                    <div className="col-md-12 text-center">
                        <button type="button" disabled={isModifiedBasicInfo()} className="btn btn-primary btn-sm m-3 px-3" onClick={saveBasicInfo}>Save</button>
                    </div>
                </div>

                <div className="row p-2 bg-light mt-3">
                    <div className="col-md-12 font-weight-700">Login Info :</div>
                </div>

                <div className="row pt-4 bg-white">
                    <div className="col-md-4 form-group">
                        <label className="font-weight-300">User Login</label>
                        <Input name="user_login" value={user.user_login} type="text" className="form-control" readOnly placeholder="Email / User Name" disabled={true} />
                    </div>
                    <div className="col-md-4 form-group">
                        <label className="font-weight-300">Current Password</label>
                        <Input onChange={handleInputChange} name="user_pass" type="password" className="form-control password cur_password" placeholder="Current Password" required="" />
                    </div>
                    <div className="col-md-4"></div>
                    <div className="col-md-4 form-group">
                        <label className="font-weight-300">New Password</label>
                        <Input onChange={handleInputChange} name="user_pass_new" type="password" className="form-control password" placeholder="New Password" required="" />
                    </div>
                    <div className="col-md-4 form-group">
                        <label className="font-weight-300 ">Confirm New Password</label>
                        <Input onChange={handleInputChange} name="user_pass_new_confirm" type="password" className="form-control password" placeholder="Confirm New Password" required="" />
                    </div>
                    <div className="col-md-12 text-center">
                        <button
                            type="button"
                            disabled={!(user.user_pass && user.user_pass_new && user.user_pass_new_confirm)}
                            className="btn btn-primary btn-sm m-3 px-3"
                            onClick={saveLoginInfo}
                        >
                            Save
                        </button>
                    </div>
                </div>

                <div className="row p-2 bg-light mt-3">
                    <div className="col-md-12 font-weight-700">Default Site :</div>
                </div>

                <div className="row bg-white">
                    <div className="col-md-12 my-4">
                        <DropdownButton
                            className="btn btn-sm dropdown-toggle text-dark p-2"
                            onOptionClick={onDefaultSiteChange}
                            default={"Choose Default Site"}
                            selected={defaultSite}
                            opts={site_locations}
                            field_attr='site_id'
                            value_attr='site_name,site_city' />


                    </div>
                    <div className="col-md-12">
                        <small><i>Once logged in, dashboard screen shows default site data by default.</i></small>
                    </div>

                    <div className="col-md-12 text-center mb-5">
                        <button className="btn btn-sm btn-primary px-3" disabled={!defaultSiteChanged} onClick={saveDefaultSite}>Save</button>
                    </div>
                </div>

                <div className="row p-2 bg-light mt-3">
                    <div className="col-md-12 font-weight-700">Default View :</div>
                </div>
                <div className="row bg-white">
                    <div className="col-md-12 text-app mt-5 pb-3">
                        <b>Select to make default screen in dashboard </b>
                    </div>
                    <div className="col-md-12">
                        <div className="row mb-2">
                            <div className="col-md-8">
                                <label className="font-weight-300 w-150" >Dashboard</label>
                                <i className={user.defaultView === 'Dashboard' ? "fas fa-lg fa-check-circle pl-5 text-primary" : "far fa-lg fa-circle pl-5 text-primary"} htmlFor="user_sns_email" onClick={() => handleDefaulViewChange("Dashboard")}></i>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-md-8">
                                <label className="font-weight-300 w-150" >Site Map</label>
                                <i className={user.defaultView === 'Site Map' ? "fas fa-lg fa-check-circle pl-5 text-primary" : "far fa-lg fa-circle pl-5 text-primary"} htmlFor="user_sns_phone" onClick={() => handleDefaulViewChange("Site Map")}></i>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8">
                                <label className="font-weight-300 w-150" >Map View</label>
                                <i className={user.defaultView === 'Map View' ? "fas fa-lg fa-check-circle pl-5 text-primary" : "far fa-lg fa-circle pl-5 text-primary"} htmlFor="user_sns_phone" onClick={() => handleDefaulViewChange("Map View")}></i>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 text-center mb-5">
                        <button className="btn btn-sm btn-primary px-3" disabled={!defaultViewChanged} onClick={saveDefaultView}>Save</button>
                    </div>
                </div>
            </div>
        </React.Fragment >
    );
}

export default ProfileSettings;